<template>
  <div class="contact sm:p-3 md:p-10 lg:p-20">
    <h1
      class="sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-2 text-gray-800 text-center underline"
    >Contact</h1>

    <div class="w-full max-w-sm ml-auto mr-auto mt-10 mb-10">
      <div class="md:flex md:items-center mb-3">
        <div class="md:w-1/3">
          <label
            class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
            for="name"
          >Name</label>
        </div>
        <div class="md:w-2/3">
          <input
            class="bg-gray-200 text-lg appearance-none border-2 border-gray-400 hover:border-orange-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-orange-500"
            id="name"
            type="text"
            v-model="name"
            value
          />
        </div>
      </div>

      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label
            class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
            for="email"
          >Email</label>
        </div>
        <div class="md:w-2/3">
          <input
            class="bg-gray-200 text-lg appearance-none border-2 border-gray-400 hover:border-orange-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-orange-500"
            id="email"
            type="email"
            v-model="email"
            value
          />
        </div>
      </div>

      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label
            class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
            for="message"
          >Message</label>
        </div>
        <div class="md:w-2/3">
          <textarea
            class="bg-gray-200 text-lg appearance-none border-2 border-gray-400 hover:border-orange-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-orange-500"
            id="message"
            type="textarea"
            v-model="message"
          />
        </div>
      </div>

      <div class="md:flex md:items-center">
        <div class="md:w-1/3"></div>
        <div class="md:w-2/3">
          <button
            class="bg-black opacity-75 font-bold text-orange-500 hover:text-white rounded-full pt-3 pb-3 align-middle px-8 w-auto shadow-lg uppercase tracking-wider"
            @click="checkForm"
          >Send</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Contact",
  data() {
    return {
      name: "",
      email: "",
      message: "",
    };
  },
  methods: {
    checkForm() {

      let contactForm = {
        name: this.name,
        email: this.email,
        message: this.message
      }

      console.log(contactForm);

      if (!this.name || !this.email || !this.message) {
        return alert("Please fill in all the fields")
      }

      axios.post("https://mailer-one.now.sh/contact", contactForm)
      .then((result) => {
        // console.log(result)
        if (result.status == 200) {
          alert("Message sent")
          this.name = "";
          this.email = "";
          this.message = "";  
        }
      }).catch((error) => {
        console.log(error)
        alert("Message failed: Please email me at jaakidup@gmail.com")
      });

    }
  }
};
</script>

<style>
</style>